import {
  AppLayout,
  AppLayoutProps,
  Box,
  ColumnLayout,
  Container,
  ContentLayout,
  Grid,
  Header,
  Link,
  SpaceBetween,
  TextContent,
  Badge,
  Button,
  Tabs,
} from "@cloudscape-design/components";
import { Mode } from "@cloudscape-design/global-styles";
import { useEffect, useState, useContext, forwardRef } from "react";
import { GlobalContext, ContentContext } from "../../../context";
import { useNavigate, useLocation } from "react-router-dom";
import { navigateFn } from "../../../routingHelper";
import SeriesNav from "../../../components/series-navbar/series-nav";
import GetSeriesContent from "../get-series-content";
import Rules from "./rules";
import Gallery from "./gallery";
import Series from "./series";
import Register from './register';
import Results from "./results";
import Calendar from "./calendar";
import DriversAndTeams from "./teams";
import Stats from "./stats";


export default function S5000_Series() {
  const navigate = navigateFn({
    navigate: useNavigate(),
    location: useLocation(),
  })
  const location = useLocation();
  const { 
    theme, setTheme, 
    density, setDensity,
    seriesContent, setSeriesContent,
  } = useContext(GlobalContext);
  

  return (
    <>
      <center>
        <div className="body-content">
          <ContentLayout
            header={
              <div className="series-header-container">
                <img 
                  className="series-header-img"
                  src={theme === Mode.Light ? "/images/s5000/s5000-header-light.png" : "/images/s5000/s5000-header-light.png"}
                />
              </div>
            }
          >
            <Container>
              <SeriesNav />
            </Container>
          </ContentLayout>
        </div>
        <div style={{
          marginTop: "50px",
          maxWidth: "2100px",
        }}> 
          {GetSeriesContent(seriesContent, Series, Results, Calendar, Rules, DriversAndTeams, Stats, Gallery, Register, Results )}
        </div>
      </center>
    </>    
  );
}
